export interface AnnualEIT105050List {
    row?: string,
    name?: string,
    amount?: string,
    indent?: number,
    rowspan?: number,
    isEdit?: boolean,
    isEdit2?: boolean,
    isEdit3?: boolean,
    isEdit4?: boolean,
    isEdit5?: boolean,
    type?: string,
    accountRecordAmount?: string,
    actualAmount?: string,
    taxDeductionRate?: string,
    previousTotalDeductions?: string,
    taxAmount?:string,
    taxAdjustmentAmount?:string,
    afterTotalDeductions?:string,

}

let list: AnnualEIT105050List[] = [
    {
        name: "一、工资薪金支出",
        row: "1",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: false,
    },
    {
        name: "其中：股权激励",
        row: "2",
        amount: "",
        indent: 2,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: false,
    },
    {
        name: "二、职工福利费支出",
        row: "3",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: true,
    },
    {
        name: "三、职工教育经费支出",
        row: "4",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit5: true,
        isEdit4: true,
    },
    {
        name: "其中：按税收规定比例扣除的职工教育经费",
        row: "5",
        amount: "",
        indent: 2,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit5: false,
    },
    {
        name: "按税收规定全额扣除的职工培训费用",
        row: "6",
        amount: "",
        indent: 4,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: true,
    },
    {
        name: "四、工会经费支出",
        row: "7",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: true,
    },
    {
        name: "五、各类基本社会保障性缴款",
        row: "8",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: true,
    },
    {
        name: "六、住房公积金",
        row: "9",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: true,
    },
    {
        name: "七、补充养老保险",
        row: "10",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        isEdit5: false,
    },
    {
        name: "八、补充医疗保险",
        row: "11",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        isEdit5: false,
    },
    {
        name: "九、其他",
        row: "12",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: false,
    },
    {
        name: "合计（1+3+4+7+8+9+10+11+12）",
        row: "13",
        amount: "",
        indent: 0,
        accountRecordAmount:"",
        actualAmount:"",
        taxDeductionRate:"",
        previousTotalDeductions:"",
        taxAmount:"",
        taxAdjustmentAmount:"",
        afterTotalDeductions:"",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit5: false,
    },


]


let AnnualEIT105050 = list
export default AnnualEIT105050
